import styled from "styled-components";

interface InfoBoxProps {
  type?: 'tip' | 'warning' | 'info';
}

export const GuideContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
`;

export const GuideHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 20px;
  background: linear-gradient(135deg, #608cdf 0%, #4a7bc8 100%);
  border-radius: 12px;
  color: white;

  h1 {
    margin: 0 0 10px 0;
    font-size: 2.5rem;
    font-weight: 700;
  }

  p {
    margin: 0;
    font-size: 1.1rem;
    opacity: 0.95;
  }
`;

export const SectionCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  transition: box-shadow 0.3s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
  width: 100%;

  .icon {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    font-size: 24px;
  }

  h2 {
    margin: 0;
    font-size: 1.8rem;
    color: #333;
    font-weight: 600;
  }
`;

export const SubSection = styled.div`
  margin: 25px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #608cdf;

  h3 {
    margin: 0 0 15px 0;
    font-size: 1.3rem;
    color: #333;
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const StepList = styled.ol`
  margin: 15px 0;
  padding-left: 25px;

  li {
    margin: 12px 0;
    font-size: 1rem;
    line-height: 1.6;
    color: #555;

    strong {
      color: #333;
    }
  }
`;

export const InfoBox = styled.div<InfoBoxProps>`
  background: ${props => {
    switch(props.type) {
      case 'tip': return '#e8f5e9';
      case 'warning': return '#fff3e0';
      case 'info': return '#e3f2fd';
      default: return '#f5f5f5';
    }
  }};
  border-left: 4px solid ${props => {
    switch(props.type) {
      case 'tip': return '#4caf50';
      case 'warning': return '#ff9800';
      case 'info': return '#2196f3';
      default: return '#9e9e9e';
    }
  }};
  padding: 15px 20px;
  margin: 15px 0;
  border-radius: 4px;

  .label {
    font-weight: 600;
    margin-bottom: 5px;
    color: ${props => {
      switch(props.type) {
        case 'tip': return '#2e7d32';
        case 'warning': return '#e65100';
        case 'info': return '#1565c0';
        default: return '#424242';
      }
    }};
  }

  p {
    margin: 8px 0;
    color: #555;
    line-height: 1.6;
  }
`;

export const DefinitionList = styled.dl`
  margin: 15px 0;

  dt {
    font-weight: 600;
    color: #608cdf;
    margin: 15px 0 5px 0;
    font-size: 1.05rem;
  }

  dd {
    margin: 0 0 10px 20px;
    color: #555;
    line-height: 1.6;
  }
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin: 20px 0;
`;

export const FeatureCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #608cdf;
    transform: translateY(-2px);
  }

  h4 {
    margin: 0 0 10px 0;
    color: #608cdf;
    font-size: 1.1rem;
  }

  p {
    margin: 0;
    color: #666;
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

// Keep for backwards compatibility if needed
export const StyledFAQUl = styled.ul`
  font-size:20px;
  ul{
    list-style: circle;
    margin-left: 10px;
    margin-bottom: 3px;
    padding: 0;
    li{
    margin-left:5px;
  }
  }

  h1{
    margin-left:0;
  }

`;